import React from 'react'

export default function CustomPageHeader({title}) {
  return (
    <h3>
        {title}
    </h3>
  )
}
